import React, { useState } from "react";
import {
  Layout,
  Menu,
  Dropdown,
  Button,
  Image,
  Avatar,
  Row,
  Col,
  Card,
  Modal,
} from "antd";
import {
  UserOutlined,
  PoweroffOutlined,
  BellFilled,
  CalendarOutlined,
  CalendarFilled,
  CarryOutFilled,
  PlusCircleFilled,
  PieChartFilled,
  SettingOutlined,
  SoundTwoTone,
  ContainerFilled,
  FontColorsOutlined,
  SwapOutlined,
  RadarChartOutlined,
  SolutionOutlined,
  DeliveredProcedureOutlined,
  ScheduleOutlined,
  FileDoneOutlined,
} from "@ant-design/icons";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { logout } from "../store/actions/auth";
import { authAxios } from "../utils";
import {
  ListNotification,
  // logoutURL,
  // ReadAllNotification,
  ReadAllNotificationURL,
  ReadNotification,
  userIDURL,
  downloadFileManualURL,
  logoutURL,
  url_get_list_city,
} from "../constants";
import moment from "moment";
import "moment/locale/vi";
import {
  getHandlPermission,
  getInfoUser,
  getProcessPermission,
  getUser,
  getUserPermission,
  getLsPermission,
  getLsCity,
  getLsDepartment,
  getLsStatusCV,
  getLsStatusTicket,
} from "../store/actions/user";

moment.locale("vi");
const { Header, Content, Footer, Sider } = Layout;
const { SubMenu } = Menu;
import Cookies from "universal-cookie";
import { getPushNotification, useErrorResizeObserver } from "./Function";
import BookTwoTone from "@ant-design/icons/lib/icons/BookTwoTone";
// import ContactsTwoTone from "@ant-design/icons/lib/icons/ContactsTwoTone";
import PhoneTwoTone from "@ant-design/icons/lib/icons/PhoneTwoTone";
const cookies = new Cookies();

const LogoImage = () => {
  return (
    <div className="logo">
      <Image
        width={180}
        height={34}
        src={`${process.env.PUBLIC_URL}/logo_new/Rainscales-logo-color.svg`}
        preview={false}
        style={{ objectFit: "cover" }}
      />
    </div>
  );
};

const LogoSmallImage = () => {
  return (
    <div className="logoSmall" style={{ background: "none" }}>
      <div className="logoSmallCrop">
        <img
          src={`${process.env.PUBLIC_URL}/logo_new/AI-white.png`}
          alt="Rainscales"
        />
      </div>
    </div>
  );
};

const arrDictHref = [
  { key: 2, arr_href: ["/", "/danhsachyeucau"] },
  { key: 3, arr_href: ["/chopheduyet"] },
  { key: 4, arr_href: ["/dapheduyet"] },
  { key: 6, arr_href: ["/danhsachxulycanhan"] },
  { key: 7, arr_href: ["/danhsachxuly"] },
  { key: 9, arr_href: ["/reports"] },
  { key: 10, arr_href: ["/export_data"] },
  {
    key: 11,
    arr_href: [
      "/settings",
      "/settings/users",
      "/settings/bophanxuly",
      "/settings/bophansudung",
      "/settings/loaiyeucau",
      "/settings/team",
      "/settings/chucvu",
      "/settings/vanphong",
    ],
  },
  { key: 12, arr_href: ["/tatcayeucau"] },
  { key: 13, arr_href: ["/change_status"] },
  { key: 14, arr_href: ["/recruitment_system"] },
  { key: 15, arr_href: ["/candidate_management"] },
  { key: 16, arr_href: ["/interview-schedule-table"] },
  // { key: 17, arr_href: ["/interview-schedule"] },
  { key: 18, arr_href: ["/report_recruitment"] },
  { key: 19, arr_href: [/detail-interview\/[^/]+$/] },
];

class CustomLayout extends React.Component {
  state = {
    collapsed: false,
    showResults: true,
    currentSelectedKeys: ["2"],
    currentOpenKeys: ["2"],
    lsNotification: [],
    countNoti: 0,
    isModalVisible: false,
    handling_permission: [],
    getRole: [],
  };

  componentDidMount() {
    // console.log(this.props.authenticated)
    useErrorResizeObserver();

    if (this.props.authenticated) {
      localStorage.removeItem("loginRedirect");
    }
    this.fetchNotification();
    window.addEventListener("refreshUserInfo", this.handleFetchUserInfo);
    try {
      setInterval(async () => {
        this.fetchNotification();
        await getPushNotification().then((res) => {
          if (res.data.length > 0) {
            const notiData = res.data[0];
            const notification = new Notification("TICKET RAINSCALES", {
              body: notiData.content,
              icon: `${process.env.PUBLIC_URL}/logo_new/AI-color.png`,
            });
            notification.onclick = function () {
              window.location.href = "/tickets/" + notiData.ticket_rel_id;
            };
          }
        });
      }, 300000);
    } catch (e) {}

    if (!this.state.auth) {
      this.handleFetchUserInfo();
      this.handleFetchCityInfo(); // 071124 bổ sung
    }

    try {
      const currentOpenKeys =
        JSON.parse(localStorage.getItem("currentOpenKeys")) || "";
      const currentSelectedKeys =
        JSON.parse(localStorage.getItem("currentSelectedKeys")) || "";
      this.setState({
        currentOpenKeys,
        currentSelectedKeys,
      });
    } catch (e) {}
  }

  componentWillUnmount() {
    window.removeEventListener("error", useErrorResizeObserver());
    window.removeEventListener("refreshUserInfo", this.handleFetchUserInfo);
  }

  NotificationsCard = (data) => {
    const [currentKey, setCurrentKey] = useState("tab1");
    const onTabChange = (key) => {
      setCurrentKey(key);
    };
    const tabList = [
      {
        key: "tab1",
        tab: "Mới",
      },
      {
        key: "tab2",
        tab: "Tất cả",
      },
    ];
    const ReadAllNotification = () => {
      authAxios(cookies.get("token"))
        .post(ReadAllNotificationURL)
        .then((res) => {
          this.fetchNotification();
        })
        .catch((err) => {
          console.log(err);
        });
    };
    const ReadNotificationFn = (notiId, ticketId) => {
      authAxios(cookies.get("token"))
        .post(ReadNotification, { notification_id: notiId })
        .then((res) => {
          // this.fetchNotification()
          window.location.href = "/tickets/" + ticketId;
        })
        .catch((err) => {
          console.log(err);
        });
    };
    const NotiNew = (listNotification) => {
      return (
        <>
          {listNotification.map((item, index) => (
            <Row
              style={{
                textAlign: "center",
                backgroundColor: "#ffffff",
                marginBottom: 5,
              }}
              key={item.id + "_" + index + item.ticket_rel}
            >
              <Col sm={6}>
                <span>{moment(item.created).format("L")}</span>
              </Col>
              <Col sm={18}>
                {item.is_view ? (
                  <a
                    style={{ color: "#e0e0e0" }}
                    onClick={(e) =>
                      ReadNotificationFn(item.id, item.ticket_rel)
                    }
                  >
                    {item.content}
                  </a>
                ) : (
                  <a
                    onClick={(e) =>
                      ReadNotificationFn(item.id, item.ticket_rel)
                    }
                  >
                    {item.content}
                  </a>
                )}
              </Col>
            </Row>
          ))}
        </>
      );
    };
    const NotiBlank = () => {
      return (
        <Row>
          <Col sm={14} offset={5}>
            <h3 style={{ fontSize: 30, textAlign: "center" }}>
              <SoundTwoTone />
            </h3>
            <h3 style={{ textAlign: "center" }}>Bạn đã xem hết thông báo</h3>
          </Col>
        </Row>
      );
    };
    const contentList = {
      tab1:
        data.data.filter((item) => !item.is_view).length > 0
          ? NotiNew(data.data.filter((item) => !item.is_view))
          : NotiBlank(),
      tab2: NotiNew(data.data),
    };
    const hasReadAll =
      data.data.filter((item) => !item.is_view).length > 0 ? (
        <a type={"primary"} onClick={(e) => ReadAllNotification()}>
          Đánh dấu đã đọc
        </a>
      ) : (
        ""
      );
    return (
      <>
        <Col span={22}>
          <Card
            className={"notification-card"}
            style={{ width: "400px", height: "500px" }}
            title="Thông báo"
            extra={hasReadAll}
            tabList={tabList}
            activeTabKey={currentKey}
            onTabChange={(key) => {
              onTabChange(key);
            }}
          >
            {contentList[currentKey]}
          </Card>
        </Col>
      </>
    );
  };

  handleFetchUserInfo = () => {
    this.setState({ loading: true });
    authAxios(cookies.get("token"))
      .get(userIDURL)
      .then((res) => {
        const {
          addUserName,
          addUserPermission,
          setIsProcess,
          addHandlPermission,
          addInfoUser,
          addLsPermission,
          addLsDepartment,
          addLsStatusCV,
          addLsStatusTicket,
        } = this.props;
        addUserName(res.data.infoUser[1]);
        addUserPermission(res.data.userPermission);
        setIsProcess(res.data.is_handling);
        addHandlPermission(res.data.handlingPermission);
        addInfoUser(res.data.infoUser);
        addLsPermission(res.data.ls_permission);
        addLsDepartment(res.data.ls_department);
        addLsStatusCV(res.data.ls_cv_status);
        addLsStatusTicket(res.data.ls_ticket_status);

        this.setState({
          loading: false,
          username: res.data.infoUser[1],
          userID: res.data.infoUser[0],
          avatar_url: res.data.infoUser[2],
          is_admin: res.data.is_admin,
          can_accept: res.data.userPermission.includes("can_accept"),
          // can_process:Object.keys(res.data.handlingPermission).length !== 0,
          can_process: res.data.is_handling,
          can_assign: res.data.can_assign,
          can_report: res.data.userPermission.includes("can_report"),
          can_system: res.data.userPermission.includes("can_system"),
          can_allticket: res.data.userPermission.includes("can_allticket"),
          can_return_ticket:
            res.data.userPermission.includes("can_return_ticket"),
          is_system_manage:
            res.data.userPermission.includes("is_system_manage"),
          is_superuser: res.data.is_superuser,

          getRole: this.props.userPermission.concat(
            Object.values(res.data.handlingPermission).flat(),
          ), // dict các key với value là array, return [] nếu handlingPermission = {}
        });
      })
      .catch((err) => {
        this.setState({ error: err, loading: false });
      });
  };

  fetchNotification = () => {
    authAxios(cookies.get("token"))
      .get(ListNotification)
      .then((res) => {
        this.setState({
          lsNotification: res.data,
          countNoti: res.data.filter((item) => item.is_view == false).length,
        });
      })
      .catch((err) => {
        this.setState({ error: err, loading: false });
      });
  };

  ReadNotification = (notiId, ticketId) => {
    authAxios(cookies.get("token"))
      .post(ReadNotification, { notificationid: notiId })
      .then((res) => {
        this.fetchNotification();
        window.location.href = "/tickets/" + ticketId;
      })
      .catch((err) => {
        this.setState({ error: err, loading: false });
      });
  };

  handleFetchCityInfo = () => {
    authAxios(cookies.get("token"))
      .get(url_get_list_city)
      .then((res) => {
        const { addLsCity } = this.props;
        addLsCity(res.data);
      })
      .catch((err) => {
        this.setState({ error: err, loading: false });
      });
  };

  logout_new = (e) => {
    // console.log("đăng xuất");
    // console.log(e);
    authAxios(cookies.get("token"))
      .get(logoutURL)
      .then((res) => {
        //tắt
        cookies.remove("token");
        cookies.remove("refresh");
        cookies.remove("csrftoken");
        sessionStorage.clear();
        window.location.href = "/login";
      });
    logout();
  };

  onCollapse = (collapsed) => {
    this.setState({ collapsed });
  };

  menu = (
    <Menu>
      {/*<Menu.Item key="1" icon={<UserOutlined/>}>*/}
      {/*    <Link to={"/profile"}>Thông tin người dùng</Link>*/}
      {/*</Menu.Item>*/}
      {/*<Menu.Item key="2" icon={<LockOutlined/>}>*/}
      {/*    <Link to={"/change_pass"}>Đổi mật khẩu</Link>*/}
      {/*</Menu.Item>*/}
      <Menu.Item
        key="3"
        icon={<PoweroffOutlined />}
        onClick={(e) => this.logout_new(e)}
      >
        Đăng xuất
      </Menu.Item>
    </Menu>
  );

  handleClick = ({ selectedKeys }) => {
    this.setState({
      currentSelectedKeys: selectedKeys,
    });
    localStorage.setItem("currentSelectedKeys", JSON.stringify(selectedKeys));
    // console.log(JSON.stringify(selectedKeys));
    // console.log(selectedKeys);
  };

  onOpenChange = (items) => {
    this.setState({ currentOpenKeys: items });
    localStorage.setItem("currentOpenKeys", JSON.stringify(items));
  };

  onUnAuth = () => {
    // console.log('un auth')
    localStorage.setItem("loginRedirect", this.props.location.pathname);
    return "";
  };
  clearRedirect = () => {
    localStorage.removeItem("loginRedirect");
    return true;
  };

  fetchFileManual = () => {
    try {
      authAxios(cookies.get("token"))
        .get(downloadFileManualURL)
        .then((res) => {
          window.open(res.data.path_file, "_blank");
        })
        .catch((err) => {
          return "";
        });
    } catch (error) {
      console.error("Fetch file URL error:", error);
    }

    // this.setState({
    //   currentSelectedKeys: selectedKeys,
    // });
    // localStorage.setItem("currentSelectedKeys", JSON.stringify(selectedKeys));
  };

  render() {
    const { authenticated, loading } = this.props;
    const {
      collapsed,
      username,
      currentOpenKeys,
      currentSelectedKeys,
      avatar_url,
      isModalVisible,
      getRole,
    } = this.state;

    arrDictHref.map((item) => {
      let boolCheckKey = false;
      for (let i of item.arr_href) {
        // if (location.href.endsWith(i)) {
        let bool_check;
        if (typeof i === "string") {
          bool_check = location.href.endsWith(i);
        } else {
          bool_check = i.test(location.href);
        }
        if (bool_check) {
          this.state.currentSelectedKeys = [item.key.toString()];
          localStorage.setItem(
            "currentSelectedKeys",
            JSON.stringify(this.state.currentSelectedKeys),
          );
          boolCheckKey = true;
          return true;
        }
      }

      if (boolCheckKey) {
        return true;
      }
    });

    return authenticated && this.clearRedirect() ? (
      <Layout>
        <Sider
          collapsible
          collapsed={collapsed}
          onCollapse={this.onCollapse}
          breakpoint="lg"
          width={250}
          collapsedWidth={40}
          style={{
            overflow: "auto",
            // height: '100vh',
            // position: 'fixed',
            // left: 0,
          }}
        >
          <a href={"https://homepage.rainscales.com.vn"}>
            {/*{ collapsed ? <LogoImage1 /> : <LogoImage /> }*/}
            {collapsed ? <LogoSmallImage /> : <LogoImage />}
          </a>
          <Menu
            theme="dark"
            mode="inline"
            openKeys={currentOpenKeys}
            selectedKeys={this.state.currentSelectedKeys}
            onSelect={this.handleClick}
            onOpenChange={this.onOpenChange}
          >
            {/*<Menu.Item key="1" icon={<UserOutlined />}><Link to="/">Trang chủ</Link></Menu.Item>*/}
            <Menu.Item key="2" icon={<CalendarOutlined />}>
              <Link to="/danhsachyeucau">Danh sách yêu cầu</Link>
            </Menu.Item>
            {this.state.can_accept ? (
              <SubMenu
                key="sub1"
                icon={<CalendarFilled />}
                title="Danh sách phê duyệt"
              >
                <Menu.Item key="3" icon={<PlusCircleFilled />}>
                  <Link to="/chopheduyet">Chờ phê duyệt</Link>
                </Menu.Item>
                <Menu.Item key="4" icon={<PlusCircleFilled />}>
                  <Link to="/dapheduyet">Đã phê duyệt</Link>
                </Menu.Item>
              </SubMenu>
            ) : (
              ""
            )}
            {this.state.can_process ? (
              <SubMenu
                key="sub2"
                icon={<CarryOutFilled />}
                title="Nhiệm vụ của tôi"
              >
                <Menu.Item key="6" icon={<PlusCircleFilled />}>
                  <Link to="/danhsachxulycanhan">Cá nhân</Link>
                </Menu.Item>
                <Menu.Item key="7" icon={<PlusCircleFilled />}>
                  <Link to="/danhsachxuly">Tất cả</Link>
                </Menu.Item>
              </SubMenu>
            ) : (
              ""
            )}
            {/*<Menu.Item key="8" icon={<UserOutlined/>}><Link to="/profile">Tài khoản của*/}
            {/*    tôi</Link></Menu.Item>*/}
            {this.state.can_report ? (
              <Menu.Item key="9" icon={<PieChartFilled />}>
                <Link to="/reports">Báo cáo</Link>
              </Menu.Item>
            ) : (
              ""
            )}
            {this.state.can_report ? (
              <Menu.Item key="10" icon={<ContainerFilled />}>
                <Link to="/export_data">Truy xuất dữ liệu</Link>
              </Menu.Item>
            ) : (
              ""
            )}
            {this.state.is_system_manage || this.state.can_system ? (
              <Menu.Item key="11" icon={<SettingOutlined />}>
                <Link to="/settings">Cấu hình hệ thống</Link>
              </Menu.Item>
            ) : (
              ""
            )}
            {this.state.is_superuser || this.state.can_allticket ? (
              <Menu.Item key="12" icon={<FontColorsOutlined />}>
                <Link
                  to="/tatcayeucau"
                  // title="Chức năng này chỉ dùng cho Super Admin và QL báo cáo (report)"
                >
                  Tất cả yêu cầu
                </Link>
              </Menu.Item>
            ) : (
              ""
            )}
            {this.state.can_return_ticket ? (
              <Menu.Item key="13" icon={<SwapOutlined />}>
                <Link
                  to="/change_status"
                  title="Chức năng này chỉ dùng cho Super Admin"
                >
                  Chuyển trạng thái ticket
                </Link>
              </Menu.Item>
            ) : (
              ""
            )}

            {this.state.getRole.includes("can_hr_rec") ? (
              <Menu.Item key="14" icon={<DeliveredProcedureOutlined />}>
                <Link to="/recruitment_system" title="Phần tuyển dụng">
                  Yêu cầu tuyển dụng
                </Link>
              </Menu.Item>
            ) : (
              ""
            )}
            {this.state.getRole.includes("can_hr_rec") ? (
              <Menu.Item key="15" icon={<SolutionOutlined />}>
                <Link to="/candidate_management" title="Phần tuyển dụng">
                  Quản Lý ứng viên
                </Link>
              </Menu.Item>
            ) : (
              ""
            )}
            {this.state.getRole.includes("can_hr_rec") ? (
              <Menu.Item key="16" icon={<ScheduleOutlined />}>
                <Link to="/interview-schedule-table" title="Phần tuyển dụng">
                  Lịch phỏng vấn
                </Link>
              </Menu.Item>
            ) : (
              ""
            )}
            {/* {this.state.is_superuser ? (
              <Menu.Item key="17" icon={<SolutionOutlined />}>
                <Link
                  to="/interview-schedule"
                  title="Chức năng này chỉ dùng cho Super Admin"
                >
                  Danh sách phỏng vấn
                </Link>
              </Menu.Item>
            ) : (
              ""
            )} */}
            {this.state.getRole.includes("can_hr_rec") ? (
              <Menu.Item key="18" icon={<RadarChartOutlined />}>
                <Link to="/report_recruitment" title="Phần tuyển dụng">
                  Báo cáo tuyển dụng
                </Link>
              </Menu.Item>
            ) : (
              ""
            )}
            {location.pathname.includes("/detail-interview/") ? (
              <Menu.Item key="19" icon={<FileDoneOutlined />}>
                <span title="Chi tiết CV phỏng vấn">Chi tiết CV phỏng vấn</span>
              </Menu.Item>
            ) : (
              ""
            )}
          </Menu>
        </Sider>

        <Layout className="site-layout" style={{ minHeight: "100vh" }}>
          <Header className="site-header-background" style={{ padding: 0 }}>
            <Menu
              theme="light"
              mode="horizontal"
              style={{
                background: "#fff",
                marginRight: "5px",
                justifyContent: "right",
              }}
            >
              <Menu.Item
                key="user-manual"
                style={{ padding: "0px 20px 0px 0px" }}
              >
                <a
                  className={"manual"}
                  href={"#"}
                  // href={"https://ticket.rainscales.com.vn/media/manual.pdf"}
                  onClick={this.fetchFileManual}
                >
                  <BookTwoTone /> &nbsp;Hướng dẫn sử dụng
                </a>
              </Menu.Item>
              <Menu.Item key="contact" style={{ padding: "0px 20px 0px 0px" }}>
                <a onClick={() => this.setState({ isModalVisible: true })}>
                  <PhoneTwoTone rotate={150} /> &nbsp;Liên hệ
                </a>
              </Menu.Item>
              {/* <Menu.Item key="ticketv1" style={{ padding: "0px 20px 0px 0px" }}>
                <a
                  className={"ticketv1"}
                  href={"https://homepage.rainscales.com.vn/ticket"}
                  target={"_blank"}
                >
                  <CalendarFilled /> &nbsp;Ticket support V1
                </a>
              </Menu.Item> */}
              <Menu.Item key="notification" style={{ padding: "0px" }}>
                <Dropdown
                  overlay={
                    <this.NotificationsCard data={this.state.lsNotification} />
                  }
                  onVisibleChange={(e) => this.fetchNotification()}
                  overlayStyle={{ height: 400 }}
                  // style={{ height: 400 }}
                >
                  <Button
                    style={{
                      border: "none",
                      background: "none",
                      boxShadow: "none",
                    }}
                  >
                    <BellFilled style={{ fontSize: 16 }} />
                    <span style={{ color: "#ff0000" }}>
                      {this.state.countNoti}
                    </span>
                  </Button>
                </Dropdown>
              </Menu.Item>
              <Menu.Item
                key="user_setting"
                style={{ padding: "0px 20px 0px 0px" }}
              >
                <Button
                  style={{
                    border: "none",
                    background: "none",
                    boxShadow: "none",
                  }}
                >
                  {avatar_url ? <Avatar src={avatar_url} /> : <UserOutlined />}{" "}
                  <span style={{ marginLeft: 5 }}>{username}</span>
                </Button>
              </Menu.Item>

              {/* 050624 Chỉ dùng tạm cho test local, khi build lên server sẽ commet nút Đăng xuất */}
              <Menu.Item
                key="3"
                icon={<PoweroffOutlined />}
                onClick={(e) => this.logout_new(e)}
              >
                Đăng xuất
              </Menu.Item>
            </Menu>
            <Modal
              title="Thông tin liên hệ"
              visible={isModalVisible}
              footer={false}
              onCancel={() => this.setState({ isModalVisible: false })}
            >
              <p>
                Nếu gặp vấn đề mặt kỹ thuật, bị lỗi, không sử dụng, hiển thị
                không đúng mô tả tool thì liên hệ
              </p>
              <p>
                Skype: <a href={"skype:vbpo.vanttt?chat"}>VanTTT RAINSCALES</a>
              </p>
              <p>
                Hoặc Email:{" "}
                <a href={"mailto:tttvan@rainscales.com"}>
                  tttvan@rainscales.com
                </a>
              </p>
            </Modal>
          </Header>
          <Content style={{ margin: "24px 16px 0", overflow: "initial" }}>
            {/* 240624 */}
            {getRole.length != 0 &&
              React.cloneElement(this.props.children, {
                data: this.state.getRole,
              })}

            {/* {React.cloneElement(this.props.children, {
              data: this.props.userPermission,
            })} */}
          </Content>
          <Footer style={{ textAlign: "center", padding: "5px" }}>
            {/* VBPO ©{new Date().getFullYear()} Made by DRI-O Team */}
            RAINSCALES ©{new Date().getFullYear()}
          </Footer>
        </Layout>
      </Layout>
    ) : (
      this.onUnAuth()
    );
  }
}

const mapStateToProps = (state) => {
  return {
    authenticated: state.auth.token !== null,
    userPermission: state.user.userPermission,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(logout()),
    addUserName: (user) => dispatch(getUser(user)),
    addUserPermission: (user) => dispatch(getUserPermission(user)),
    setIsProcess: (bool) => dispatch(getProcessPermission(bool)),
    addHandlPermission: (user) => dispatch(getHandlPermission(user)),
    addInfoUser: (user) => dispatch(getInfoUser(user)),
    addLsPermission: (user) => dispatch(getLsPermission(user)),
    addLsCity: (user) => dispatch(getLsCity(user)),
    addLsDepartment: (user) => dispatch(getLsDepartment(user)),
    addLsStatusCV: (user) => dispatch(getLsStatusCV(user)),
    addLsStatusTicket: (user) => dispatch(getLsStatusTicket(user)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CustomLayout),
);
